import React, { useEffect, useRef, useState } from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';

let activeFilterField: string | null = null;
let activeCaret: number | null = null;

const TextFilterCell = (props: GridFilterCellProps) => {
  const field = props.field || '';
  const [value, setValue] = useState<string>(props.value || '');
  const inputRef = useRef<HTMLInputElement>(null);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  useEffect(() => {
    if (activeFilterField === field && inputRef.current) {
      const el = inputRef.current;
      el.focus();
      const pos = activeCaret ?? el.value.length;
      el.setSelectionRange(pos, pos);
    }
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [field]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    activeFilterField = field;
    activeCaret = e.target.selectionStart;

    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      props.onChange({
        value: newValue,
        operator: newValue ? 'contains' : '',
        syntheticEvent: e,
      });
    }, 400);
  };

  return (
    <td>
      <input
        ref={inputRef}
        type="text"
        className="k-textbox"
        value={value}
        onChange={handleChange}
        onBlur={(e) => {
          if (e.relatedTarget) {
            activeFilterField = null;
            activeCaret = null;
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
      />
    </td>
  );
};

export default TextFilterCell;
